globalThis.appCustomerSpace = globalThis.appCustomerSpace || {};
appCustomerSpace.Modals = appCustomerSpace.Modals || {};
appCustomerSpace.Modals.GoogleMyBusiness = appCustomerSpace.Modals.GoogleMyBusiness || {};

appCustomerSpace.Modals.GoogleMyBusiness.AddMediaItems = (function(superClass)
{
    utils.extend(AddMediaItems, superClass);

    function AddMediaItems($html) {
        this.$html = $html;
        return AddMediaItems.__super__.constructor.apply(this, arguments);
    }

    $.extend(AddMediaItems.prototype, {
        init: function() {
            appCustomerSpace.LimitlessPlugins.Selects.Single.init(this.$html);
            this.initUploader();

            AddMediaItems.__super__.init.apply(this, arguments);
        },
        initUploader: function() {
            var controller          = this,
                $mediaUploader      = controller.$html.find(".file-styled");

            $mediaUploader.uniform({
                fileButtonClass: 'action btn btn-default'
            });
            $mediaUploader.on('change', function() {
                const $input    = $(this),
                      filenames = $.map($input[0].files, file => file.name);
                $input.siblings('.filename').html(filenames.join(', '));
            });
        }
    });

    return AddMediaItems;
})(appCustomerSpace.Modal);
